module.exports = __webpack_public_path__ + "static/8-0e3a26df920dfd66c2456539c1fc7a15.jpg";